import { apiSlice } from './apiSlice';

export const squadDataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getSquadData: builder.query({
      query: () => ({
        url: "squad-data",
      }),
      transformResponse: (response) => ({ entries: response }),
      providesTags: (result) =>
        result?.entries
          ? [
              ...result.entries.map((entry) => ({
                type: 'SquadData',
                id: entry._id,
              })),
              { type: 'SquadData', id: 'LIST' },
            ]
          : [{ type: 'SquadData', id: 'LIST' }],
    }),
    createSquadData: builder.mutation({
      query: (data) => ({
        url: 'squad-data',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'SquadData', id: 'LIST' }],
    }),
    updateSquadData: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `squad-data/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: [{ type: 'SquadData', id: 'LIST' }],
    }),
    deleteSquadData: builder.mutation({
      query: (id) => ({
        url: `squad-data/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'SquadData', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetSquadDataQuery,
  useCreateSquadDataMutation,
  useUpdateSquadDataMutation,
  useDeleteSquadDataMutation,
} = squadDataApiSlice;
